import { render, staticRenderFns } from "./aboutUsTitleLine.vue?vue&type=template&id=1932ec72&scoped=true"
import script from "./aboutUsTitleLine.vue?vue&type=script&lang=js"
export * from "./aboutUsTitleLine.vue?vue&type=script&lang=js"
import style0 from "./aboutUsTitleLine.vue?vue&type=style&index=0&id=1932ec72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1932ec72",
  null
  
)

export default component.exports